import React from 'react';
import { motion } from 'framer-motion';
export function CTAFinal() {
  const scrollToPlanes = () => document.getElementById('planes')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section id="contacto" className="py-24 sm:py-28 px-6 bg-brand-background relative overflow-hidden scroll-mt-20" data-id="element-85">
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-86">
        <img src="https://images.unsplash.com/photo-1682687982501-1e58f814714e?q=80&w=2070&auto=format&fit=crop" alt="Fondo submarino" className="w-full h-full object-cover" data-id="element-87" />
        <div className="absolute inset-0 bg-brand-background mix-blend-multiply" data-id="element-88"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-90">
          <h2 className="text-white font-heading font-black text-4xl sm:text-5xl md:text-6xl uppercase tracking-tight mb-5 leading-tight" data-id="element-91">
            Tu primera inmersión no empieza en el agua
          </h2>

          <p className="text-brand-details text-xl sm:text-2xl font-light mb-10 max-w-2xl mx-auto" data-id="element-92">
            Empieza el día que decidís dar el primer paso.
          </p>

          <button onClick={scrollToPlanes} className="inline-block text-center w-full sm:w-auto bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] font-bold uppercase tracking-widest py-5 px-10 rounded-full transition-all duration-300 transform hover:scale-[1.03] active:scale-[0.98] shadow-[0_10px_40px_-5px_rgba(0,184,217,0.5)] hover:shadow-[0_16px_55px_-5px_rgba(0,184,217,0.75)] text-lg" data-id="element-93">
            Quiero empezar a bucear
          </button>
        </motion.div>
      </div>
    </section>;
}